(function(){
  function initMotion(){
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var allVideos = Array.prototype.slice.call(document.querySelectorAll('video'));
    var tryPlay = function(v){ if (!(v.getAttribute('src') || v.querySelector('source'))) return; var p = v.play(); if (p && p.catch) p.catch(function(){}); };
    // iOS: reproducir cuando entra en pantalla y en el primer toque
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) tryPlay(e.target); else if (!e.target.hasAttribute('data-keep-playing')) e.target.pause(); });
      }, { threshold: 0.2 });
      allVideos.forEach(function(v){ vio.observe(v); });
    }
    if (!window.__fyTouch) {
      window.__fyTouch = true;
      var kick = function(){ Array.prototype.forEach.call(document.querySelectorAll('video'), function(v){ v.muted = true; tryPlay(v); }); };
      ['touchstart','touchend','click','scroll'].forEach(function(ev){ document.addEventListener(ev, kick, { once:true, passive:true }); });
    }

    allVideos.forEach(function(v){
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('autoplay', '');
      var play = function(){ tryPlay(v); };
      v.addEventListener('loadedmetadata', play, { once:true });
      v.addEventListener('canplay', play, { once:true });
      if (v.getAttribute('src') || v.querySelector('source')) {
        play();
        if (v.hasAttribute('data-keep-playing') && !v.dataset.keep) {
          v.dataset.keep = '1';
          v.addEventListener('pause', play);
          v.addEventListener('click', function(e){ e.preventDefault(); play(); });
          document.addEventListener('visibilitychange', function(){ if (!document.hidden) play(); });
        }
      }
    });

    // alto real del header para la marquesina sticky
    var head = document.getElementById('fy-header');
    if (head) {
      // el sticky real se aplica al wrapper de seccion de Shopify (si existe)
      var hw = head.closest('[id^="shopify-section-"]');
      if (hw) hw.classList.add('fy-sticky-header');
      var mq = document.querySelector('.fy-sticky-mq');
      if (mq) { var mw = mq.closest('[id^="shopify-section-"]'); if (mw) mw.classList.add('fy-sticky-mq-wrap'); }
      var setH = function(){
        var h = (hw || head).getBoundingClientRect().height;
        document.documentElement.style.setProperty('--fy-header-h', Math.round(h) + 'px');
      };
      setH();
      window.addEventListener('resize', setH, { passive:true });
      setTimeout(setH, 400);
      // ningun ancestro puede recortar el sticky
      var p = head.parentElement;
      while (p && p !== document.body) { var o = getComputedStyle(p).overflow; if (o !== 'visible') p.style.overflow = 'visible'; p = p.parentElement; }
    }

    var bar = document.getElementById('fy-progress');
    if (bar && !bar.dataset.ready) {
      bar.dataset.ready = '1';
      var onScroll = function(){
        var se = document.scrollingElement || document.documentElement;
        var top = window.scrollY || se.scrollTop || 0;
        var h = se.scrollHeight - se.clientHeight;
        bar.style.width = (h > 0 ? Math.min(100, (top / h) * 100) : 0) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive:true });
      window.addEventListener('load', onScroll);
      onScroll();
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-fy-sound]'), function(btn){
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      var card = btn.closest('article'); var vid = card && card.querySelector('video'); if (!vid) return;
      var label = btn.querySelector('[data-label]'), wave = btn.querySelector('[data-wave]');
      var paint = function(){ var on = !vid.muted; label.textContent = on ? 'Silenciar' : 'Sonido'; wave.style.display = on ? '' : 'none'; };
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var turnOn = vid.muted;
        Array.prototype.forEach.call(document.querySelectorAll('video'), function(o){ o.muted = true; });
        vid.muted = !turnOn; vid.volume = 1;
        var p = vid.play(); if (p && p.catch) p.catch(function(){});
        Array.prototype.forEach.call(document.querySelectorAll('[data-fy-sound] [data-label]'), function(l){ l.textContent = 'Sonido'; });
        Array.prototype.forEach.call(document.querySelectorAll('[data-fy-sound] [data-wave]'), function(w){ w.style.display = 'none'; });
        paint();
      });
      paint();
    });

    var menuBtn = document.getElementById('fy-menu-btn');
    var menu = document.getElementById('fy-menu');
    if (menuBtn && menu && !menuBtn.dataset.ready) {
      menuBtn.dataset.ready = '1';
      menuBtn.addEventListener('click', function(){
        var open = menu.style.display === 'grid';
        menu.style.display = open ? 'none' : 'grid';
        menuBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    if (reduce) return;

    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]:not([data-revealed])'));
    els.forEach(function(el){
      el.setAttribute('data-revealed', '');
      el.style.opacity = '0';
      el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity .75s cubic-bezier(.2,.7,.2,1), transform .75s cubic-bezier(.2,.7,.2,1)';
    });
    var counters = Array.prototype.slice.call(document.querySelectorAll('[data-count]:not([data-counted])'));
    counters.forEach(function(el){ el.setAttribute('data-counted',''); });

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        if (el.hasAttribute('data-count')) {
          var target = parseFloat(el.getAttribute('data-count'));
          var suffix = el.getAttribute('data-count-suffix') || 'M';
          var t0 = performance.now(), dur = 1200;
          var step = function(now){
            var k = Math.min(1, (now - t0) / dur);
            var v = target * (1 - Math.pow(1 - k, 3));
            el.textContent = '+' + (k < 1 ? v.toFixed(1) : target) + suffix;
            if (k < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
          return;
        }
        var sibs = el.parentElement ? Array.prototype.slice.call(el.parentElement.querySelectorAll(':scope > [data-reveal]')) : [];
        var i = Math.max(0, sibs.indexOf(el));
        el.style.transitionDelay = Math.min(i * 90, 360) + 'ms';
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }, { rootMargin:'0px 0px -12% 0px', threshold:0.15 });

    els.concat(counters).forEach(function(el){ io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMotion);
  else initMotion();
  document.addEventListener('shopify:section:load', initMotion);
})();
